import {
	ErrorMessage as ErrorMessageComponent,
	type ErrorMessageProps as ErrorMessagePropsType
} from './ErrorMessage';

export const ErrorMessage = ErrorMessageComponent;
export type ErrorMessageProps = ErrorMessagePropsType;
